import { useState } from 'react';
import { Button, Box, Typography, Input, Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import SendIcon from '@mui/icons-material/Send';
import UploadIcon from '@mui/icons-material/Upload';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import propTypes from 'prop-types';
const MySwal = withReactContent(Swal);

export const TemplateUploader = ({ selectedTemplate, selectedState }) => {
  const organization = useSelector((state) => state.app.organization);
  const template = { ...selectedTemplate };
  const chatStatus = selectedState?.key;
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileInput = (event) => {
    try {
      const file = event.target.files[0];
      const allowedFormats = ['.csv'];
      if (file) {
        const fileExtension = `.${file.name.split('.').pop()}`;

        if (allowedFormats.includes(fileExtension)) {
          setSelectedFile(file);
        } else {
          // El archivo tiene un formato no válido
          MySwal.fire({
            text: 'Archivo nó válido. Por favor, revisá que el archivo sea un formato csv',
            showConfirmButton: true,
            icon: 'error',
            inputValue: true,
          }).then(() => {
            event.target.value = null;
            setSelectedFile(null);
          });
        }
      }
    } catch (error) {
      console.log('handleFileInput error', error);
    }
  };

  const handleUpload = () => {
    setLoading(true);
    try {
      if (!selectedFile) {
        setError('Debe seleccionar un archivo');
        return;
      }

      // eslint-disable-next-line no-undef
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(selectedFile);

      fileReader.onload = async (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Obtener el nombre de la primera hoja
        const sheetName = workbook.SheetNames[0];

        // Obtener los datos de la hoja
        const sheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false, defval: '' });

        // Obtener la cabecera
        const header = rows[0];

        // Procesar los datos de cada fila a partir de la segunda fila
        const processedRows = rows
          .slice(1)
          .filter((row) => row.length > 0)
          .map((row) => {
            if (row && row[0]) {
              const destination = row[0];
              const params = row.slice(1).toString();
              return [destination, ...params.split(',')];
            }
          });

        // Agregar la cabecera al resultado
        processedRows.unshift(header);

        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: { organization, rows: processedRows, template, chatStatus },
        };

        await axios(process.env.REACT_APP_NOTIFICATIONS_URL, requestOptions)
          .then(() => {
            MySwal.fire({
              text: '¡Los datos cargados fueron procesados correctamente!',
              showConfirmButton: true,
              icon: 'success',
              inputValue: true,
            });

            setSelectedFile(null);
          })
          .catch((error) => {
            let errorMessage = 'Disculpe ha ocurrido un error, por favor intente nuevame más tarde';
            if (error && error.response && error.response.data) errorMessage = error.response.data;
            MySwal.fire({
              text: errorMessage,
              showConfirmButton: true,
              icon: 'error',
              inputValue: true,
            });
            setSelectedFile(null);
          });
        setLoading(false);
      };
    } catch (error) {
      setLoading(true);
      console.log('handleUpload error', error);
    }
  };

  return (
    <>
      {!selectedFile ? (
        <>
          <Grid item sm={12}>
            <Box>
              <Input
                type="file"
                accept=".csv"
                onChange={handleFileInput}
                sx={{ display: 'none' }}
                id="upload-excel"
              />
              <label htmlFor="upload-excel">
                <Button
                  variant="outlined"
                  component="span"
                  sx={{ mt: '15px' }}
                  startIcon={<UploadIcon />}
                >
                  Cargar archivo
                </Button>
              </label>
            </Box>
          </Grid>
          <Grid item sm={12}>
            <Box>
              <Typography variant="body1">{selectedFile ? selectedFile.name : error}</Typography>
            </Box>
          </Grid>
        </>
      ) : (
        <>
          <Grid item sm={12}>
            <Button
              variant="contained"
              onClick={handleUpload}
              endIcon={!loading ? <SendIcon /> : <CircularProgress size={20} />}
              disabled={loading}
              sx={{ mt: '15px' }}
            >
              Enviar archivo
            </Button>
          </Grid>
        </>
      )}
    </>
  );
};
const Props = {
  selectedTemplate: propTypes.object,
  selectedState: propTypes.object,
};
TemplateUploader.propTypes = Props;
